import { IProductAnalyzerState } from "./productAnalyzer.types";

export const initialState: IProductAnalyzerState = {
  productDetail: null,
  loadingProductDetail: false,
  profitCalculator: {
    salePrice: 0,
    costPrice: 0,
    fulfilmentType: "FBA",
    fbmCost: 0,
    storageTime: 0,
    minRoi: 0,
    minProfit: 0,
    prepFee: 0,
    inboundShipping: 0,
    inboundPlacementService: "Optimized",
    miscFee: 0,
    miscFeePercent: 0,
    closingFee: 0,
    storageFee: 0,
    totalDiscount: 0,
    multipackQuantity: 1,
    quantity: 1,
  },
  feeRules: {
    referralFeeRule: "",
    fbaFeeRule: [],
    inboundPlacementServiceFeeRule: [],
  },
  offers: null,
  loadingOffers: false,
  quickInfo: null,
  loadingQuickInfo: false,
  restrictions: null,
  loadingRestrictions: false,
  eBay: {
    searchEBay: "",
    soldOnEBay: "",
  },
  sellerCentral: {
    home: "",
    addProduct: "",
    inventory: "",
    orders: "",
  },
  alerts: null,
  offersFilter: {
    prime: true,
    live: true,
  },
  ranksAndPrices: null,
  loadingRanks: false,
  loadingBuyBox: false,
  keepa: "",
  loadingKeepa: false,
  notes: [],
  loadingNotes: false,
  chartsData: [],
  loadingChartsData: false,
  averages: null,
  loadingAverages: false,
  variations: [],
  histories: [],
  loadingHistories: false,
  historyCount: 0,
  tags: [],
  buyBoxSellerIdHistory: [],
  csv: [],
};
